import {AxiosResponse} from 'axios';
import {PostAffliationsReport} from '../backend/requests/post-affliations-report';
import {PostCareTasksReport} from '../backend/requests/post-care-tasks-report';
import {PostOccurrencesReport} from '../backend/requests/post-occurrences-report';
import {PostSeniorCareRecordReport} from '../backend/requests/post-senior-care-record';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class EntityReportsRepository {
  // Singleton Instance
  private static _instance: EntityReportsRepository;

  // Private
  private logger: Logger;

  static get instance(): EntityReportsRepository {
    if (!this._instance) {
      this._instance = new EntityReportsRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('EntityReportsRepository');
  }

  // Get care tasks
  public async careTasks({
    entityId,
    sort,
    body,
  }: {
    entityId: string;
    sort?: string;
    body?: PostCareTasksReport;
  }): Promise<any[]> {
    // Build query params
    const queryParams = `?entityId=${entityId}${sort ? `&sort=${sort}` : ''}`;

    const result: AxiosResponse<any[]> = await BackendApiManager.instance.post(
      '/reports/care-tasks' + queryParams,
      body
    );

    // Done
    return result.data;
  }

  public async affliations({
    entityId,
    sort,
    body,
  }: {
    entityId: string;
    sort?: string;
    body?: PostAffliationsReport;
  }): Promise<any[]> {
    // Build query params
    const queryParams = `?entityId=${entityId}${sort ? `&sort=${sort}` : ''}`;

    const result: AxiosResponse<any[]> = await BackendApiManager.instance.post(
      '/reports/affiliations' + queryParams,
      body
    );

    // Done
    return result.data;
  }

  public async occurrences({
    entityId,
    sort,
    body,
  }: {
    entityId: string;
    sort?: string;
    body?: PostOccurrencesReport;
  }): Promise<any[]> {
    // Build query params
    const queryParams = `?entityId=${entityId}${sort ? `&sort=${sort}` : ''}`;

    const result: AxiosResponse<any[]> = await BackendApiManager.instance.post(
      '/reports/occurrences' + queryParams,
      body
    );

    // Done
    return result.data;
  }

  public async seniorCareRecords({
    entityId,
    userId,
    sort,
    body,
  }: {
    entityId: string;
    userId: string;
    sort?: string;
    body?: PostSeniorCareRecordReport;
  }): Promise<any[]> {
    // Build query params
    const queryParams = `?entityId=${entityId}&userId=${userId}${sort ? `&sort=${sort}` : ''}`;

    const result: AxiosResponse<any[]> = await BackendApiManager.instance.post(
      '/reports/senior-care-records' + queryParams,
      body
    );

    // Done
    return result.data;
  }
}
